module.exports = __webpack_public_path__ + "static/media/linkedin-icon--white.11fec888.svg";